import {SetAttributes} from './Edit';
import {__} from '@wordpress/i18n';
import {CheckboxControl} from '@wordpress/components';

export type ShowCountOptions = {
	'show-count': boolean;
}

type Props = {
	attributes: ShowCountOptions;
	setAttributes: SetAttributes;
};

/**
 * Show Count option for the category menus.
 *
 * @author OnPoint Plugins
 * @since  9.1.0
 */
const ShowCount = ( {attributes, setAttributes}: Props ) => {
	return ( <>
		<CheckboxControl
			label={__( 'Show post counts', 'advanced-sidebar-menu' )}
			checked={attributes[ 'show-count' ]}
			onChange={value => {
				setAttributes( {
					'show-count': !! value,
				} );
			}}
		/>
	</> );
};

export default ShowCount;
